import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import IconButton from '@mui/material/IconButton';
import { useNavigate } from 'react-router-dom';

export default function BackButton(): React.JSX.Element {
  const navigate = useNavigate();
  return (
    <IconButton
      sx={{ height: '40px', width: '40px', mt: 1 }}
      color="primary"
      onClick={() => navigate(-1)}
    >
      <ArrowBackIcon sx={{ transform: 'scale(1.3)' }} />
    </IconButton>
  );
}
